import React from 'react';

export default function AMap() {
	return (
		<article className="a-map">
			<iframe
				frameBorder="0"
				src="https://www.google.com/maps/embed/v1/place?q=Doornzeelsestraat%2058b%2C%20Evergem&key=AIzaSyB-wEqWiVYA0wLVgxZ0RP5GLjX6jdW__BM"
				title="Aertech location"
			/>
		</article>
	);
}



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.map.js